import { isGraphQLEnum, isGraphQLInputType, isGraphQLInterface, isGraphQLScalar, isGraphQLType, isGraphQLUnion, isGraphQLDirective, isGraphQLTypeExtension, isGraphQLInputTypeExtension, isGraphQLEnumExtension, isGraphQLUnionExtension, isGraphQLScalarExtension, isGraphQLInterfaceExtension, } from './utils';
import { mergeType } from './type';
import { mergeEnum } from './enum';
import { mergeScalar } from './scalar';
import { mergeUnion } from './union';
import { mergeInputType } from './input-type';
import { mergeInterface } from './interface';
import { mergeDirective } from './directives';
import { collectComment } from './comments';
export function mergeGraphQLNodes(nodes, config) {
    return nodes.reduce(function (prev, nodeDefinition) {
        var node = nodeDefinition;
        if (node && node.name && node.name.value) {
            var name_1 = node.name.value;
            if (config && config.commentDescriptions) {
                collectComment(node);
            }
            if (config &&
                config.exclusions &&
                (config.exclusions.includes(name_1 + '.*') || config.exclusions.includes(name_1))) {
                delete prev[name_1];
            }
            else if (isGraphQLType(nodeDefinition) || isGraphQLTypeExtension(nodeDefinition)) {
                prev[name_1] = mergeType(nodeDefinition, prev[name_1], config);
            }
            else if (isGraphQLEnum(nodeDefinition) || isGraphQLEnumExtension(nodeDefinition)) {
                prev[name_1] = mergeEnum(nodeDefinition, prev[name_1], config);
            }
            else if (isGraphQLUnion(nodeDefinition) || isGraphQLUnionExtension(nodeDefinition)) {
                prev[name_1] = mergeUnion(nodeDefinition, prev[name_1], config);
            }
            else if (isGraphQLScalar(nodeDefinition) || isGraphQLScalarExtension(nodeDefinition)) {
                prev[name_1] = mergeScalar(nodeDefinition, prev[name_1], config);
            }
            else if (isGraphQLInputType(nodeDefinition) || isGraphQLInputTypeExtension(nodeDefinition)) {
                prev[name_1] = mergeInputType(nodeDefinition, prev[name_1], config);
            }
            else if (isGraphQLInterface(nodeDefinition) || isGraphQLInterfaceExtension(nodeDefinition)) {
                prev[name_1] = mergeInterface(nodeDefinition, prev[name_1], config);
            }
            else if (isGraphQLDirective(nodeDefinition)) {
                prev[name_1] = mergeDirective(nodeDefinition, prev[name_1]);
            }
        }
        return prev;
    }, {});
}
//# sourceMappingURL=merge-nodes.js.map